import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import store from '@/store'
import TokenService from "@/common/token.service.js";

const ApiService = {
    init() {
        Vue.use(VueAxios, axios)
        Vue.axios.defaults.baseURL = process.env.VUE_APP_API_URL
        this.setDefaultHeaders()
        this.registerInterceptors()
    },

    setDefaultHeaders() {
        Vue.axios.defaults.headers.common = {
            "X-Requested-With": "XMLHttpRequest",
            "Accept": "application/json",
            "Content-Type": "application/json",
            "Language": "en",
            "Authorization": `Bearer ${TokenService.get()}`
        }
    },

    registerInterceptors() {
        Vue.axios.interceptors.request.use(
            function (config) {
                store.commit('general/ajax_running', true, { root: true })
                return config;
            },
            function (error) {
                store.commit('general/ajax_running', false, { root: true })
                return Promise.reject(error);
            }
        );
        // On response
        var self = this
        Vue.axios.interceptors.response.use(
            function (response) {
                store.commit('general/ajax_running', false, { root: true })
                return response;
            },
            function (error) {
                store.commit('general/ajax_running', false, { root: true })
                if (!error.response) {
                    console.log(error.message);
                } else if (error.response.status === 401) {
                    // 401 => Unauthorized
                    TokenService.removeAll();
                    self.resetHeaders();
                    window.location.href = '/';
                } else {
                    return Promise.reject(error);
                }
            }
        );
    },

    setAuthHeader(token) {
        Vue.axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
    },

    hasAuthHeader() {
        return Vue.axios.defaults.headers.common["Authorization"] !== null || Vue.axios.defaults.headers.common["Authorization"] !== "undefined"
    },

    resetHeaders() {
        Vue.axios.defaults.headers.common = {};
    },

    setLanguage(lang) {
        Vue.axios.defaults.headers.common["Language"] = lang
        Vue.axios.defaults.headers.common["Accept-Language"] = lang
    },

    get(resource, params) {
        return Vue.axios
            .get(`${resource}`, params)
    },

    post(resource, params, headers) {
        return Vue.axios
            .post(`${resource}`, params, headers)
    },

    update(resource, params) {
        return Vue.axios
            .put(`${resource}`, params)
    },

    delete(resource, params) {
        return Vue.axios
            .delete(`${resource}`, params)
    }
}

export default ApiService
